export const introduce = {
  text: '智能合约供应量占比统计了智能合约中token的供应量百分比',
  height: 1200,
};
